import { ApiError } from './api';

export function authErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    switch (error.code) {
      case 'email_exists':
        return 'این ایمیل قبلاً ثبت شده است.';
      case 'invalid_credentials':
        return 'ایمیل یا گذرواژه نادرست است.';
      case 'rate_limited':
        return 'تعداد تلاش‌های ناموفق بیش از حد مجاز است. کمی بعد دوباره تلاش کنید.';
      case 'validation_error':
        return 'اطلاعات واردشده معتبر نیست. فیلدها را بررسی کنید.';
      case 'origin_mismatch':
        return 'درخواست نامعتبر است. صفحه را تازه‌سازی کنید و دوباره تلاش کنید.';
      case 'unauthorized':
        return 'نشست شما منقضی شده است. دوباره وارد شوید.';
      case 'not_implemented':
        return 'این قابلیت هنوز فعال نیست.';
      default:
        break;
    }
    if (error.status >= 500) {
      return 'خطای سرور رخ داد. کمی بعد دوباره تلاش کنید.';
    }
  }
  if (error instanceof TypeError) {
    return 'ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی کنید.';
  }
  return 'خطای غیرمنتظره‌ای رخ داد. دوباره تلاش کنید.';
}
